<template>
    <output
        aria-live="polite"
        class="flex w-full items-start gap-3 rounded-lg border border-[#2e7fad] bg-[#ebf8ff] p-2.5 text-sm leading-5 text-black"
        data-testid="ai-draft-unsupported-alert"
    >
        <span class="min-w-0 grow whitespace-normal break-words">{{ message }}</span>
        <button
            class="inline-flex shrink-0 items-center justify-center p-0 text-black"
            data-testid="ai-draft-unsupported-dismiss"
            type="button"
            :aria-label="dismissLabel"
            :class="closeControlClasses"
            @click="emit('dismiss')"
        >
            <icon aria-hidden="true" class="h-full w-full" name="bold/close" />
        </button>
    </output>
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    const props = withDefaults(
        defineProps<{
            closeControl?: 'email' | 'sms';
            dismissLabel: string;
            message: string;
        }>(),
        {
            closeControl: 'sms',
        }
    );

    const emit = defineEmits<{
        dismiss: [];
    }>();

    const closeControlClasses = computed<string>(() =>
        props.closeControl === 'email' ? 'h-5 w-5 sm:h-4 sm:w-4' : 'h-5 w-5'
    );
</script>
